// extracted by mini-css-extract-plugin
export default {"tagContainer":"BadgeListItem_tagContainer__bno7N","tagText":"BadgeListItem_tagText__IkcJw"};